import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'

import { transformInventoryLog } from '@/components/cart/helpers/transformHelpers'

export const useInventoryLogStore = defineStore('inventory-log', {
  state: () => ({
    inventoryLogData: [],
    pagination: {},
  }),

  actions: {
    async getInventoryLog(filters) {
      const response = await api.inventoryTracking.getInventoryLogs(filters)
      const { inventoryLogs, pagination } = response.data
      const transformedLogs = inventoryLogs.map(transformInventoryLog)
      this.inventoryLogData = transformedLogs
      this.pagination = pagination
      return response.data.pagination
    },

    async downloadInventoryLog(searchTerm) {
      const response = await api.inventoryTracking.downloadInventoryLog(searchTerm)
      return response
    },

    resetState() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInventoryLogStore, import.meta.hot))
}
